import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';
import { Column } from 'angular-slickgrid';

export class CountAggregator extends SLAggregator {
	protected _name = 'count';
	protected _label = 'Count';
	constructor() {
		super();
	}
	init() {
		super.init();
		for (const column of this._columns) {
			this._value[column.id] = 0;
		}
	}
	Accumulate(item: any, column:Column<any>) {
		if (!item[column.id]) {
			return;
		}
		this._value[column.id] += 1;
	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);
	}
}